import React from "react";
import {
    ControlLabel,
    FormControl,
    FormGroup,
    Checkbox,
    Button,
    Panel,
    Row,
    Col,
} from "react-bootstrap";
import { useEventContext, useModuleSettingsContext } from "../../../../context";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import { activityTopCalculate } from "../../../../../api/player";
import { activityTypes, countUsersMax, countUsersMin } from "./lib";
import HelpHintButton from "components/HelpHintButton";

const Activity = () => {
    const {
        moduleActivity,
        onSaveActivity,
        setPropertyActivity,
        isSaving,
    } = useModuleSettingsContext();
    const { event } = useEventContext();

    const setCount = () => {

        const counts = {
            visibleCount: moduleActivity.visibleCount, 
            calculateCount: moduleActivity.calculateCount, 
        }

        Object.keys(counts).forEach(count => {
            if (counts[count] < countUsersMin) {
                counts[count] = countUsersMin
            } else if (counts[count] > countUsersMax) {
                counts[count] = countUsersMax
            }
        })

        if (counts.visibleCount > counts.calculateCount) {
            counts.calculateCount = counts.visibleCount
        }

        setPropertyActivity('visibleCount', counts.visibleCount);
        setPropertyActivity('calculateCount', counts.calculateCount);
        onSaveActivity(counts);
    }

    const setPoints = (field, value) => {
        if (value < 0) {
            return;
        }

        setPropertyActivity(field, value);
    }

    return (
        <Panel style={{ flex: 1 }}>
            <PanelHeading>
                <PanelTitle>Активный участник</PanelTitle>
            </PanelHeading>
            <PanelBody>
                <FormGroup>
                    <Checkbox
                        checked={moduleActivity.enabled}
                        onChange={(e) => onSaveActivity({ enabled: e.target.checked })}
                    >Включить Активный участник</Checkbox>
                </FormGroup>
                {moduleActivity.enabled && (
                    <>
                        <FormGroup>
                            <ControlLabel>Пользователей в топе</ControlLabel>
                            <Row>
                                <Col xs={6}>
                                    <p>В плеере</p>
                                    <FormControl
                                        type="number"
                                        value={moduleActivity.visibleCount}
                                        onChange={(e) => setPropertyActivity('visibleCount', parseInt(e.target.value) || countUsersMin)}
                                        onBlur={setCount}
                                        disabled={isSaving}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <p>В статистике</p>
                                    <FormControl
                                        type="number"
                                        value={moduleActivity.calculateCount}
                                        onChange={(e) => setPropertyActivity('calculateCount', parseInt(e.target.value) || countUsersMin)}
                                        onBlur={setCount}
                                        disabled={isSaving}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <hr />
                        <ControlLabel>
                            Баллы
                            <HelpHintButton placement="right">
                                <p>Баллы могут быть целыми числами без дробной части</p>
                            </HelpHintButton>
                        </ControlLabel>
                        {Object.keys(activityTypes).map((code) => (
                            <FormGroup key={code}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: 10 }}>
                                    <span>{activityTypes[code].name}</span>
                                    {code === 'quizQuestionCorrectAnswerPoints' && <HelpHintButton placement="right">
                                        <p>Баллы начисляются только за правильные ответы</p>
                                        <p>Если правильных ответов несколько, баллы начисляются только если выбраны все правильные ответы</p>
                                        <p>Если правильного ответа нет, баллы также начисляются</p>
                                        <p>Если указан неправильный или не полный ответ, баллы не начисляются</p>
                                    </HelpHintButton>}
                                </div>
                                <FormControl
                                    type="number"
                                    value={moduleActivity[code]}
                                    onChange={(e) => setPoints(code, parseInt(e.target.value) || 0)}
                                    onBlur={() => onSaveActivity({ [code]: moduleActivity[code] })}
                                    disabled={isSaving}
                                />
                            </FormGroup>
                        ))}
                        <FormGroup>
                            <ControlLabel>Посмотрел более х минут эфира</ControlLabel>
                            <Row>
                                <Col xs={6}>
                                    <p>Количество минут</p>
                                    <FormControl
                                        type="number"
                                        value={parseInt(moduleActivity.longViewingTime / 60)}
                                        onChange={(e) => setPoints('longViewingTime', (parseInt(e.target.value) || 0) * 60)}
                                        onBlur={() => onSaveActivity({ longViewingTime: moduleActivity.longViewingTime })}
                                        disabled={isSaving}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <p>Баллы</p>
                                    <FormControl
                                        type="number"
                                        value={moduleActivity.longViewingPoints}
                                        onChange={(e) => setPoints('longViewingPoints', parseInt(e.target.value) || 0)}
                                        onBlur={() => onSaveActivity({ longViewingPoints: moduleActivity.longViewingPoints })}
                                        disabled={isSaving}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <hr />
                        <FormGroup style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                            <ControlLabel>Подсчёт баллов</ControlLabel>
                            <Button onClick={() => activityTopCalculate(event.eventKey)}>
                                Запустить
                            </Button>
                        </FormGroup>
                    </>
                )}
            </PanelBody>
        </Panel>
    );
};

export default Activity;